import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

/**
 * The email OTP page (Laravel: introduce-register-step2.blade.php) was removed at the client's
 * request: the emailed link proves the email, and Azure B2C verifies it again at Set Password.
 * Kept only so an old /step2/ address (e.g. a tab left open across the release) lands on the
 * final details step instead of a dead page.
 */
const IntroducedInvestorStep2: React.FC = () => {
  const { uniqueCode } = useParams<{ uniqueCode: string }>();
  const { search } = useLocation();
  return <Navigate to={`/investor/introduced/step4/${uniqueCode}${search}`} replace />;
};

export default IntroducedInvestorStep2;
